module.exports = __webpack_public_path__ + "static/media/girl.c64d8de6.png";